module.exports = __webpack_public_path__ + "static/media/personal-values-large.dfe13c05.png";